import ImageView from '../ImageView/ImageView';
import styles from './RoundIconLabelUnit.module.scss';

export interface RoundIconLabelUnitProps {
  iconImageUrl: string;
  labelText: string;
  subLabelText?: string;
  size?: 'small' | 'default';
}

function RoundIconLabelUnit({ iconImageUrl, labelText, subLabelText, size = 'default' }: RoundIconLabelUnitProps) {
  const componentStyles = styles;

  return (
    <div className={`${componentStyles.componentStyle} ${componentStyles[`${size}Container`]}`}>
      <div className={`${componentStyles.iconImage} ${componentStyles[`${size}IconImage`]}`}>
        <ImageView src={iconImageUrl} isCircled />
      </div>
      <div className={componentStyles.labelContainer}>
        {subLabelText && <p className={componentStyles.subLabel}>{subLabelText}</p>}
        <p className={`${componentStyles.label} ${componentStyles[`${size}Label`]}`}>{labelText}</p>
      </div>
    </div>
  );
}

export default RoundIconLabelUnit;
